
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSyntheticNocogIec as ObiAisTargetSyntheticNocogIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-synthetic-nocog-iec.js';
 
 
 

 
 export const ObiAisTargetSyntheticNocogIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-synthetic-nocog-iec',
   elementClass: ObiAisTargetSyntheticNocogIecElement,
   events: {
     
   }
  });
 
 